function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_18",
  "data-name": "Group 18",
  transform: "translate(-86 -321)",
  opacity: 0.255
}, React.createElement("path", {
  id: "Polygon_1",
  "data-name": "Polygon 1",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(86 321)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_16",
  "data-name": "Polygon 16",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(164 321)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_8",
  "data-name": "Polygon 8",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(125 321)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_11",
  "data-name": "Polygon 11",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(203 321)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_4",
  "data-name": "Polygon 4",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(104 321)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_12",
  "data-name": "Polygon 12",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(183 321)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_6",
  "data-name": "Polygon 6",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(145 321)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_10",
  "data-name": "Polygon 10",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(224 321)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_2",
  "data-name": "Polygon 2",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(106 330) rotate(180)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_15",
  "data-name": "Polygon 15",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(185 330) rotate(180)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_7",
  "data-name": "Polygon 7",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(147 330) rotate(180)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_13",
  "data-name": "Polygon 13",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(226 330) rotate(180)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_3",
  "data-name": "Polygon 3",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(127 330) rotate(180)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_14",
  "data-name": "Polygon 14",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(205 330) rotate(180)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_5",
  "data-name": "Polygon 5",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(166 330) rotate(180)",
  fill: "#707070"
}), React.createElement("path", {
  id: "Polygon_9",
  "data-name": "Polygon 9",
  d: "M5.5,0,11,9H0Z",
  transform: "translate(244 330) rotate(180)",
  fill: "#707070"
}));

var SvgProfileSeperator = function SvgProfileSeperator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 158,
    height: 9,
    viewBox: "0 0 158 9",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProfileSeperator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-seperator.8dbb16d3.svg";
export { ForwardRef as ReactComponent };